import React from "react";
import {Button, FormGroup, Input, Label} from "reactstrap";
import {memesValeurs, resoudre} from "../../../screen/fonds/reglages";

/**
 * Panneau de réglages d'un fond, fabriqué à partir de la description que le fond déclare (voir screen/fonds/reglages.js) :
 * un curseur par nombre, une case par interrupteur, une liste par choix. Aucun fond n'a de code à écrire ici.
 *
 * @param schema         description des réglages du fond
 * @param valeurs        valeurs en cours de modification (le brouillon, aussi montré dans l'aperçu du fond)
 * @param enregistrees   valeurs enregistrées sur le serveur
 * @param onChange       (cle, valeur) : un réglage change
 * @param onEnregistrer  enregistrer le brouillon
 * @param onOrigine      remettre toutes les valeurs d'origine dans le brouillon
 * @param titre          (facultatif) titre du panneau, « Réglages du fond » par défaut
 * @param ouvert         (facultatif) panneau déroulé dès l'affichage (replié par défaut)
 */
export default function ReglagesFond({schema, valeurs, enregistrees, onChange, onEnregistrer, onOrigine, titre = "Réglages du fond", ouvert: ouvertAuDepart = false}) {
    // le panneau reste ouvert ou fermé selon le choix de la personne, jamais selon les valeurs (sinon il se refermait dès qu'on
    // revenait aux valeurs enregistrées)
    const [ouvert, setOuvert] = React.useState(ouvertAuDepart);
    const cles = Object.keys(schema);
    if (cles.length === 0) return null;

    const actuelles = resoudre(schema, valeurs);
    const modifie = !memesValeurs(schema, valeurs, enregistrees);
    const origine = memesValeurs(schema, valeurs, {});

    return (
        <details className="mt-2 mb-3" open={ouvert} onToggle={e => setOuvert(e.target.open)}>
            <summary style={{cursor: "pointer"}}><strong>{titre}</strong> ({cles.length}){modifie && <span className="badge badge-warning ml-2">non enregistrés</span>}</summary>
            <div className="pt-2">
                {cles.map(cle => {
                    const d = schema[cle];
                    const id = "reglage-" + cle + "-" + d.libelle.length;
                    return (
                        <FormGroup key={cle} className="mb-2">
                            {d.type === "nombre" && (<>
                                <Label className="mb-0 small" for={id}>{d.libelle} : <strong>{actuelles[cle]}{d.unite ? " " + d.unite : ""}</strong></Label>
                                <Input type="range" bsSize="sm" id={id} min={d.min} max={d.max} step={d.pas || 1} value={actuelles[cle]}
                                       onChange={e => onChange(cle, Number(e.target.value))}/>
                            </>)}
                            {d.type === "interrupteur" && (
                                <Label check className="small">
                                    <Input type="checkbox" checked={actuelles[cle]} onChange={e => onChange(cle, e.target.checked)}/> {d.libelle}
                                </Label>
                            )}
                            {d.type === "choix" && (<>
                                <Label className="mb-0 small" for={id}>{d.libelle}</Label>
                                <Input type="select" bsSize="sm" id={id} value={actuelles[cle]} onChange={e => onChange(cle, e.target.value)}>
                                    {d.options.map(o => <option key={o.valeur} value={o.valeur}>{o.libelle}</option>)}
                                </Input>
                            </>)}
                            {d.aide && <small className="text-muted d-block">{d.aide}</small>}
                        </FormGroup>
                    );
                })}
                <Button size="sm" color="primary" disabled={!modifie} onClick={onEnregistrer}>Enregistrer</Button>
                <Button size="sm" color="secondary" className="ml-2" disabled={origine} onClick={onOrigine}>Valeurs d'origine</Button>
            </div>
        </details>
    );
}
